
import React, { Fragment } from 'react';
import { useContext } from 'react';
import { UL } from '../../../AbstractElements';
import CustomizerContext from '../../../_helper/Customizer';
import LogoutClass from './Logout';
import Notifications from './Notifiations';
import { Col } from 'reactstrap';

const Rightbar = () => {
    const { sidebarResponsive } = useContext(CustomizerContext);

    return (
        <Fragment>
            <Col className="nav-right col-6 pull-right right-header p-0">
                <UL attrUL={{ className: `simple-list d-flex flex-row nav-menus ${sidebarResponsive ? 'open' : ''}` }}>
                    <Notifications />
                    <LogoutClass />
                </UL>
            </Col>
        </Fragment>
    );
};

export default Rightbar;